import { ReactSVG } from "react-svg";
import leftCloud from "../../../assets/images/enhanced-sign-in/desktop-left-cloud.svg";
import rightCloud from "../../../assets/images/enhanced-sign-in/desktop-right-cloud.svg";
import leftPurpleCloud from "../../../assets/images/portal/desktop/left-cloud.svg";
import rightPurpleCloud from "../../../assets/images/portal/desktop/right-cloud.svg";
import ConditionalRender from "../conditional-render";
import classNames from "classnames";
import { InteractivePortalLogo } from "..";

const CloudsContainer = ({ children, applyPurpleClouds = false, isLogoClickDisabled = false }) => {

    return (
        <div className="h-screen w-screen relative">
            <ConditionalRender condition={applyPurpleClouds}>
                <ReactSVG src={leftPurpleCloud} className="absolute left-0 top-0 opacity-40" />
                <ReactSVG src={rightPurpleCloud} className="absolute right-0 bottom-0 opacity-40" />
            </ConditionalRender>
            <ConditionalRender condition={!applyPurpleClouds}>
                <ReactSVG src={leftCloud} className="absolute left-0 top-0 opacity-40" />
                <ReactSVG src={rightCloud} className="absolute right-0 bottom-0 opacity-40" />
            </ConditionalRender>
            <InteractivePortalLogo
                isDesktop
                className={classNames("absolute px-[3.125rem] py-[2.43rem] z-20", { "cursor-pointer" : !isLogoClickDisabled } )}
                isLogoClickDisabled={isLogoClickDisabled} 
            />
            <div className="relative z-10 h-full w-full px-[3.125rem] py-[2.43rem]">
                <div className="h-full w-full">
                    <div className="h-full w-full flex justify-center items-center">
                        {children}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CloudsContainer;